import React from 'react';
import classNames from 'classnames';
import useBlogMenuSettings from '../../hooks/use-blog-menu-settings';
import SearchButton from '../search-button';
import styles from './header-buttons.scss';

export const HeaderButtons: React.FC = () => {
  const { showSearch } = useBlogMenuSettings();

  return (
    <div className={classNames(styles.container, 'header-buttons')}>
      {showSearch ? renderSearchButton() : null}
    </div>
  );
};

function renderSearchButton() {
  return (
    <div className={styles.searchButton}>
      <SearchButton />
    </div>
  );
}

export default HeaderButtons;
